// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gjp6Y","top":"styles_top__PsYmm"};